<template>
  <div :id="$attrs['id']" :class="['grid grid--row-gap', gridClasses]">
    <slot :current-page="currentPage" :page-number="pageNumber" :base-index="(pageNumber - 1) * itemsPerPage" />
    <div v-if="pages > 1" :class="paginateColumns" class="hm-table__td hm-table__td--no-hover">
      <div class="pagination">
        <hm-button :class="[{'disabled': pageNumber == 1}]"
                   class="btn--no-padding"
                   cols="1"
                   icon-left="back-2c"
                   @click="pageNumber = 1" />
        <hm-button :class="[{'disabled': pageNumber == 1}]"
                   class="btn--no-padding"
                   cols="1"
                   icon-left="back-1c"
                   @click="pageNumber = Math.max(1, pageNumber - 1)" />
        <hm-button v-if="pageNumber > pages - 2 && pageNumber >= 5" cols="1" @click="pageNumber = pageNumber - 4" v-html="pageNumber - 4" />
        <hm-button v-if="pageNumber > pages - 1 && pageNumber >= 4" cols="1" @click="pageNumber = pageNumber - 3" v-html="pageNumber - 3" />
        <hm-button v-if="pageNumber >= 3" cols="1" @click="pageNumber = pageNumber - 2" v-html="pageNumber - 2" />
        <hm-button v-if="pageNumber >= 2" cols="1" @click="pageNumber = pageNumber - 1" v-html="pageNumber - 1" />
        <hm-button class="disabled" cols="1" @click="pageNumber = pageNumber" v-html="pageNumber" />
        <hm-button v-if="pageNumber + 1 <= pages" cols="1" @click="pageNumber = pageNumber + 1" v-html="pageNumber + 1" />
        <hm-button v-if="pageNumber + 2 <= pages" cols="1" @click="pageNumber = pageNumber + 2" v-html="pageNumber + 2" />
        <hm-button v-if="pageNumber <= 2 && pageNumber + 3 <= pages" cols="1" @click="pageNumber = pageNumber + 3" v-html="pageNumber + 3" />
        <hm-button v-if="pageNumber == 1 && pageNumber + 4 <= pages" cols="1" @click="pageNumber = pageNumber + 4" v-html="pageNumber + 4" />
        <hm-button :class="[{'disabled': pageNumber === pages}]"
                   class="btn--no-padding"
                   cols="1"
                   icon-left="forward-1c"
                   @click="pageNumber = Math.min(pages, pageNumber + 1)" />
        <hm-button :class="[{'disabled': pageNumber === pages}]"
                   class="btn--no-padding"
                   cols="1"
                   icon-left="forward-2c"
                   @click="pageNumber = pages" />
      </div>
    </div>
  </div>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { split, endsWith, head, isNil, isEmpty, slice, isString, cloneDeep, toNumber } from 'lodash';
import uuid from 'uuid';
import GridMixin from '../../../mixins/GridMixin';

export default {
  name: 'Pagination',

  mixins: [HotelmeisterMixin, GridMixin],

  props: {
    allRows: {
      type: Array,
      required: true,
      default: () => [],
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 10,
    },
  },

  data: function () {
    return {
      pageNumber: 1,
    };
  },

  computed: {
    pages: function () {
      return Math.ceil(this.allRows.length / this.itemsPerPage);
    },
    currentPage: function () {
      const offset = (this.pageNumber - 1) * this.itemsPerPage;
      return slice(this.allRows, offset, offset + this.itemsPerPage);
    },
    paginateColumns: function () {
      return 'col-12';
    },
  },

  watch: {
    allRows: function (newVal, oldVal) {
      this.$nextTick(() => {
        this.pageNumber = this.pageNumber >= this.pages ? this.pages : this.pageNumber;
      });
    },
  },

  created: function () {
  },

  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "~styles/import";

  .quick-action-button {
    padding: 0!important;
  }

  .btn--no-padding {
    padding-right: 0!important;
  }

  .pagination {
    display: grid;
    grid-auto-columns: 3.5rem;
    grid-template-rows: auto;
    grid-column-gap: 1rem;
    float: right;

    .btn--inline {
      background-color: $white;
      justify-content: center;
      &.disabled {
        color: $middlegray;
        cursor: not-allowed;
        &:hover {
          background: inherit;
          border: 1px solid $middlegray;
        }
      }
    }

    * {
      grid-row: 1;
    }
  }
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/table/Pagination.vue